import clsx from 'clsx'
import type { VideoHTMLAttributes } from 'react'
import styles from './FeaturePreviewVideo.module.css'

export default function FeaturePreviewVideo({
	className,
	...props
}: VideoHTMLAttributes<HTMLVideoElement>) {
	return (
		<video className={clsx(styles.video, className)} autoPlay muted loop playsInline {...props}>
			您的浏览器不支持 video 标签。
		</video>
	)
}
